/* Mon Beau Bon Bœuf — panier + chrome interactif (port fidèle de la maquette sur le panier Shopify).
   Tiroir panier, barres « livraison gratuite dès X $ » (header + tiroir), nudge bas-droite,
   suggestions, toast, menu mobile, module code postal (démo).
   Endpoints Shopify : /cart.js, /cart/add.js, /cart/change.js. */
(function () {
  'use strict';
  var CFG = window.MBBTHEME || {};
  var FREE_SHIP = CFG.freeShip || 12500; // en cents
  var T = CFG.t || {};
  function tt(k, fb) { return T[k] || fb; }

  var fmt = function (cents) {
    var n = cents / 100;
    return (Number.isInteger(n) ? n.toLocaleString('fr-CA') : n.toFixed(2).replace('.', ',')) + ' $';
  };
  function progressHTML(gap) {
    return tt('progress', 'Plus que [montant] pour la livraison gratuite')
      .replace('[montant]', '<strong class="text-ink-900">' + fmt(gap) + '</strong>');
  }

  var state = { cart: null, pool: null, nudgeCollapsed: false, nudgeArmed: false };
  var els = {};
  // Compteur d'analyse maison (mbb-analytics.js) — silencieux si absent ou sans consentement
  function trk(n) { try { if (window.mbbTrack) window.mbbTrack(n); } catch (e) {} }

  function $(id) { return document.getElementById(id); }

  function grab() {
    els = {
      count: $('cartCount'), countLabel: $('cartCountLabel'),
      items: $('cartItems'), empty: $('cartEmpty'), footer: $('cartFooter'), pamBox: $('cartPamBox'),
      subtotal: $('cartSubtotal'), shipBar: $('shipBar'), shipFill: $('shipFill'), shipMsg: $('shipMsg'),
      drawer: $('cartDrawer'), overlay: $('cartOverlay'), upsell: $('cartUpsell'),
      headerShip: $('headerShip'), headerShipMsg: $('headerShipMsg'), headerShipFill: $('headerShipFill'), headerShipIcon: $('headerShipIcon'),
      nudgeCard: $('nudgeCard'), nudgeFab: $('nudgeFab'), nudgeMsg: $('nudgeMsg'), nudgeFill: $('nudgeFill'),
      nudgeSuggest: $('nudgeSuggest'), nudgeFabAmount: $('nudgeFabAmount'),
      toast: $('toast'), toastMsg: $('toastMsg')
    };
  }

  /* ───────── Toast ───────── */
  var toastTimer;
  window.mbbToast = function (msg) {
    if (!els.toast) return;
    els.toastMsg.textContent = msg;
    els.toast.style.transform = 'translateX(-50%) translateY(0)';
    els.toast.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      els.toast.style.transform = 'translateX(-50%) translateY(6rem)';
      els.toast.style.opacity = '0';
    }, 2600);
  };

  /* ───────── API panier Shopify ───────── */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addItem(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ───────── Rendu du tiroir ───────── */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Propriétés de ligne écrites par les apps (Filljoy poids réel, contenu de bundle,
  // étiquette de cadeau, gravure…). Celles préfixées « _ » sont techniques → masquées.
  function propsHTML(i) {
    var p = i.properties;
    if (!p) return '';
    var rows = Object.keys(p).filter(function (k) {
      return k.charAt(0) !== '_' && p[k] !== null && p[k] !== '';
    }).map(function (k) {
      return '<div class="text-[11.5px] text-ink-400 leading-snug">' + esc(k) + ' : <span class="text-ink-600">' + esc(p[k]) + '</span></div>';
    });
    return rows.length ? '<div class="mt-1 space-y-0.5">' + rows.join('') + '</div>' : '';
  }

  // Remises appliquées à la ligne (cadeau BOGOS, rabais de bundle…).
  // Sans ça, le client verrait le prix plein alors que l'app a bel et bien remisé.
  function discountsHTML(i) {
    var d = i.line_level_discount_allocations;
    if (!d || !d.length) return '';
    return '<div class="mt-1 space-y-0.5">' + d.map(function (a) {
      return '<div class="inline-flex items-center gap-1.5 text-[11.5px] text-success"><i class="ph-fill ph-tag text-[11px]"></i> ' +
        esc(a.discount_application && a.discount_application.title ? a.discount_application.title : '') +
        ' (−' + fmt(a.amount) + ')</div>';
    }).join('') + '</div>';
  }

  // Prix : si une remise s'applique, le prix original est barré à côté du prix final.
  function priceHTML(i) {
    var final = '<span class="font-mono text-[14px] text-ink-900">' + fmt(i.final_line_price) + '</span>';
    if (i.original_line_price && i.original_line_price > i.final_line_price) {
      return '<div class="flex items-baseline gap-1.5"><s class="font-mono text-[12px] text-ink-300">' + fmt(i.original_line_price) + '</s>' + final + '</div>';
    }
    return final;
  }

  function lineHTML(i) {
    return '<div class="flex gap-3.5 items-start">' +
      '<a href="' + i.url + '" class="w-16 h-16 rounded-[8px] overflow-hidden bg-surface-2 ring-1 ring-ink-900/8 shrink-0 block">' +
      (i.image ? '<img src="' + i.image + '&width=160" alt="" class="w-full h-full object-cover" onerror="this.src=\'' + i.image + '\'" />' : '') + '</a>' +
      '<div class="flex-1 min-w-0">' +
        '<div class="flex items-start justify-between gap-2">' +
          '<div class="min-w-0"><a href="' + i.url + '" class="text-[14px] font-medium text-ink-900 leading-tight hover:text-brand-red transition">' + i.product_title + '</a>' +
          (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="text-[12px] text-ink-400 mt-0.5">' + i.variant_title + '</div>' : '') +
          propsHTML(i) + discountsHTML(i) + '</div>' +
          '<button class="js-remove text-ink-300 hover:text-brand-red transition shrink-0" data-key="' + i.key + '" aria-label="Retirer ' + i.product_title + '"><i class="ph ph-trash text-[16px]"></i></button>' +
        '</div>' +
        '<div class="flex items-center justify-between mt-2.5">' +
          '<div class="stepper inline-flex items-center rounded-full ring-1 ring-ink-900/12 bg-surface h-8">' +
            '<button class="js-dec w-8 h-8 grid place-items-center rounded-full hover:bg-surface-2 text-ink-700" data-key="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Diminuer"><i class="ph-bold ph-minus text-[12px]"></i></button>' +
            '<span class="w-7 text-center font-mono text-[13px] text-ink-900 tabular-nums">' + i.quantity + '</span>' +
            '<button class="js-inc w-8 h-8 grid place-items-center rounded-full hover:bg-surface-2 text-ink-700" data-key="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Augmenter"><i class="ph-bold ph-plus text-[12px]"></i></button>' +
          '</div>' +
          priceHTML(i) +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    state.cart = cart;
    var c = cart.item_count;
    var sub = cart.items_subtotal_price;

    if (els.count) { els.count.textContent = c > 9 ? '9+' : c; els.count.style.transform = c > 0 ? 'scale(1)' : 'scale(0)'; }
    if (els.countLabel) els.countLabel.textContent = c + (c > 1 ? ' articles' : ' article');

    if (els.items) {
      var has = !!cart.items.length;
      els.items.style.display = has ? 'block' : 'none';
      if (els.empty) els.empty.style.display = has ? 'none' : 'flex';
      if (els.footer) els.footer.style.display = has ? 'block' : 'none';
      if (els.shipBar) els.shipBar.style.display = has ? 'block' : 'none';
      if (els.upsell) els.upsell.style.display = has ? 'block' : 'none';
      if (els.pamBox && !has) { els.pamBox.style.display = 'none'; els.pamBox.innerHTML = ''; }
      if (has) els.items.innerHTML = cart.items.map(lineHTML).join('');
    }

    if (els.subtotal) els.subtotal.textContent = fmt(sub);
    var pct = Math.min(100, (sub / FREE_SHIP) * 100);
    if (els.shipFill) {
      els.shipFill.style.width = pct + '%';
      els.shipFill.style.background = sub >= FREE_SHIP ? '#1E7A4D' : '#B91C1C';
    }
    if (els.shipMsg) {
      els.shipMsg.innerHTML = sub >= FREE_SHIP
        ? '<i class="ph-fill ph-check-circle text-success text-[15px]"></i> <span class="text-success font-medium">' + tt('unlocked', 'Livraison gratuite débloquée !') + '</span>'
        : '<i class="ph-fill ph-truck text-ink-400 text-[15px]"></i> <span>' + progressHTML(FREE_SHIP - sub) + '</span>';
    }

    // Barre header (visible dès le 1er article)
    if (els.headerShip) {
      if (cart.items.length) {
        els.headerShip.classList.remove('hidden');
        els.headerShipFill.style.width = pct + '%';
        els.headerShipFill.style.background = sub >= FREE_SHIP ? '#1E7A4D' : '#B91C1C';
        if (sub >= FREE_SHIP) {
          els.headerShipIcon.className = 'ph-fill ph-check-circle text-success text-[14px] shrink-0';
          els.headerShipMsg.innerHTML = '<strong class="text-success">' + tt('unlocked', 'Livraison gratuite débloquée !') + '</strong>';
        } else {
          els.headerShipIcon.className = 'ph-fill ph-truck text-brand-red text-[14px] shrink-0';
          els.headerShipMsg.innerHTML = progressHTML(FREE_SHIP - sub);
        }
      } else {
        els.headerShip.classList.add('hidden');
      }
    }

    renderPamBox();
    renderUpsell(sub);
    renderNudge(sub, c);
    document.dispatchEvent(new CustomEvent('mbb:cart', { detail: cart }));
  }

  /* ───────── Suggestions (pool = produits de la collection du nudge) ─────────
     Le pool ne contient QUE des produits réellement achetables : proposer une rupture
     de stock envoyait le client sur un bouton « Ajouter » qui échoue. Le cache expire
     après 10 minutes, sinon un produit épuisé en cours de visite resterait suggéré
     jusqu'à la fermeture de l'onglet. */
  var POOL_KEY = 'mbb-pool-v2'; // v2 : les pools déjà en cache contenaient des épuisés
  var POOL_MS = 10 * 60 * 1000;
  function loadPool() {
    if (state.pool) return Promise.resolve(state.pool);
    try {
      var cached = JSON.parse(sessionStorage.getItem(POOL_KEY) || 'null');
      if (cached && cached.at && Date.now() - cached.at < POOL_MS) {
        state.pool = cached.list; return Promise.resolve(state.pool);
      }
    } catch (e) {}
    var url = (CFG.nudgeCollectionUrl || '/collections/all') + '/products.json?limit=100';
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      state.pool = (d.products || []).map(function (p) {
        var v = null;
        for (var k = 0; k < p.variants.length; k++) { if (p.variants[k].available !== false) { v = p.variants[k]; break; } }
        if (!v) return null; // aucune variante disponible → le produit ne doit pas être suggéré
        return {
          productId: p.id, variantId: v.id, title: p.title,
          price: Math.round(parseFloat(v.price) * 100),
          url: '/products/' + p.handle,
          image: (p.images && p.images[0] && p.images[0].src) || ''
        };
      }).filter(Boolean);
      try { sessionStorage.setItem(POOL_KEY, JSON.stringify({ at: Date.now(), list: state.pool })); } catch (e) {}
      return state.pool;
    }).catch(function () { state.pool = []; return state.pool; });
  }

  function pickSuggestions(gap, n) {
    var inCart = {};
    (state.cart && state.cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; });
    var avail = (state.pool || []).filter(function (p) { return !inCart[p.productId] && p.price > 0; });
    var crossing = avail.filter(function (p) { return p.price >= gap; }).sort(function (a, b) { return a.price - b.price; });
    var below = avail.filter(function (p) { return p.price < gap; }).sort(function (a, b) { return b.price - a.price; });
    return crossing.concat(below).slice(0, n);
  }

  function suggestionRow(p, gap, idx, compact) {
    var unlocks = p.price >= gap;
    var meta = unlocks
      ? '<span class="inline-flex items-center gap-1 text-success"><i class="ph-fill ph-check-circle text-[12px]"></i> ' + tt('unlocked', 'Livraison gratuite débloquée !').replace(/\s*!$/, '') + '</span>'
      : fmt(p.price);
    return '<div class="flex items-center gap-2.5 px-1 ' + (idx > 0 ? 'mt-1 pt-2.5 border-t border-ink-900/8' : '') + '">' +
      '<a href="' + p.url + '" class="shrink-0"><img src="' + (p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '') + '" alt="" loading="lazy" class="' + (compact ? 'w-8 h-8' : 'w-10 h-10') + ' rounded-[7px] object-cover bg-surface-2 prod-edge" /></a>' +
      '<div class="flex-1 min-w-0"><a href="' + p.url + '" class="block text-[12.5px] font-medium text-ink-900 truncate hover:text-brand-red transition">' + p.title + '</a><div class="text-[11.5px] text-ink-500 leading-tight">' + meta + '</div></div>' +
      '<button class="js-add shrink-0 inline-flex items-center gap-1 h-8 px-3 rounded-full bg-ink-900 text-white text-[12px] font-medium hover:bg-brand-red transition" data-variant-id="' + p.variantId + '" aria-label="' + tt('add', 'Ajouter') + ' ' + p.title + '"><i class="ph-bold ph-plus text-[12px]"></i> ' + tt('add', 'Ajouter') + '</button>' +
    '</div>';
  }

  /* Boîte prêts-à-manger : dès que le panier contient N plats du rayon (2 par défaut),
     on propose la boîte juste en dessous — c'est presque toujours plus avantageux. */
  var pamIds = null;
  function loadPamIds() {
    if (pamIds) return Promise.resolve(pamIds);
    if (!CFG.pamCollectionUrl) { pamIds = {}; return Promise.resolve(pamIds); }
    try {
      var c = sessionStorage.getItem('mbb-pam');
      if (c) { pamIds = JSON.parse(c); return Promise.resolve(pamIds); }
    } catch (e) {}
    return fetch(CFG.pamCollectionUrl + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        pamIds = {};
        (d.products || []).forEach(function (p) { pamIds[p.id] = 1; });
        try { sessionStorage.setItem('mbb-pam', JSON.stringify(pamIds)); } catch (e) {}
        return pamIds;
      }).catch(function () { pamIds = {}; return pamIds; });
  }
  function pamBoxPick() {
    var box = CFG.pamBox;
    if (!box || !box.variantId || !pamIds) return null;
    var items = (state.cart && state.cart.items) || [];
    var count = 0, hasBox = false;
    items.forEach(function (i) {
      if (String(i.product_id) === String(box.productId)) hasBox = true;
      else if (pamIds[i.product_id]) count += i.quantity;
    });
    if (hasBox || count < (CFG.pamThreshold || 2)) return null;
    return box;
  }

  /* Encart dédié, juste sous les articles — bien avant les suggestions du panier */
  function renderPamBox() {
    var host = els.pamBox;
    if (!host) return;
    loadPamIds().then(function () {
      var box = pamBoxPick();
      if (!box) { host.style.display = 'none'; host.innerHTML = ''; return; }
      host.style.display = 'block';
      host.innerHTML =
        '<div class="rounded-[14px] bg-brand-red/10 p-4" style="box-shadow:inset 0 0 0 1px rgba(185,28,28,.25)">' +
          '<div class="font-mono text-[10.5px] uppercase tracking-[0.18em] text-brand-red mb-2.5">' +
            tt('upsellPam', 'Vous aimez nos prêts-à-manger ?') + '</div>' +
          '<div class="flex items-center gap-3">' +
            '<a href="' + box.url + '" class="shrink-0"><img src="' + (box.image ? box.image : '') + '" alt="" loading="lazy" class="w-16 h-16 rounded-[10px] object-cover bg-surface-2 prod-edge" /></a>' +
            '<div class="flex-1 min-w-0">' +
              '<a href="' + box.url + '" class="block text-[13.5px] font-semibold text-ink-900 leading-tight hover:text-brand-red transition">' + box.title + '</a>' +
              '<div class="text-[12px] text-ink-600 mt-1">' + tt('pamBoxNote', 'Le rayon complet, en une boîte') + ' · <span class="font-mono">' + fmt(box.price) + '</span></div>' +
            '</div>' +
            '<button class="js-add shrink-0 inline-flex items-center gap-1 h-10 px-4 rounded-full bg-brand-red text-white text-[13px] font-medium hover:bg-brand-red-hover transition" data-variant-id="' + box.variantId + '" aria-label="' + tt('add', 'Ajouter') + ' ' + box.title + '"><i class="ph-bold ph-plus text-[13px]"></i> ' + tt('add', 'Ajouter') + '</button>' +
          '</div>' +
        '</div>';
    });
  }

  function renderUpsell(sub) {
    if (!els.upsell) return;
    var gap = FREE_SHIP - sub;
    Promise.all([loadPool(), loadPamIds()]).then(function () {
      var box = pamBoxPick(); // déjà mis en avant plus haut : on ne le répète pas ici
      var picks = pickSuggestions(Math.max(gap, 1), 3)
        .filter(function (p) { return !box || p.productId !== box.productId; });
      if (!picks.length) { els.upsell.style.display = 'none'; return; }
      var head = gap > 0 ? tt('upsellGap', 'On ajoute pour la livraison gratuite ?') : tt('upsellGeneral', 'On ajoute souvent');
      els.upsell.innerHTML = '<div class="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-400 mb-3">' + head + '</div>' +
        '<div class="space-y-1">' + picks.map(function (p, i) { return suggestionRow(p, gap, i, false); }).join('') + '</div>';
    });
  }

  /* ───────── Nudge bas-droite ───────── */
  function renderNudge(sub, count) {
    if (!els.nudgeCard) return;
    var gap = FREE_SHIP - sub;
    var blocked = document.body.classList.contains('no-scroll');

    if (count > 0 && gap <= 0) {
      if (state.nudgeArmed && !blocked) setTimeout(function () { window.mbbToast(tt('unlockedToast', '🎉 Livraison gratuite débloquée !')); }, 60);
      state.nudgeArmed = false;
    } else if (count > 0 && gap > 0) {
      state.nudgeArmed = true;
    } else {
      state.nudgeArmed = false;
    }

    // Pas sur la page panier : l'info y est déjà deux fois (récapitulatif + barre du header),
    // et la pastille venait se poser par-dessus le bouton « Passer au paiement ».
    var onCartPage = document.body.classList.contains('template-cart');
    var show = count > 0 && gap > 0 && !blocked && !onCartPage;
    if (!show) { els.nudgeCard.classList.remove('is-in'); els.nudgeFab.classList.remove('is-in'); return; }

    els.nudgeMsg.innerHTML = progressHTML(gap);
    els.nudgeFill.style.width = Math.min(100, (sub / FREE_SHIP) * 100) + '%';
    els.nudgeFabAmount.textContent = fmt(gap);
    loadPool().then(function () {
      var picks = pickSuggestions(gap, 2);
      els.nudgeSuggest.innerHTML = picks.length
        ? picks.map(function (p, i) { return suggestionRow(p, gap, i, true); }).join('')
        : '<div class="px-1 py-1 text-[12px] text-ink-400">Ajoutez un article pour débloquer la livraison gratuite.</div>';
    });
    els.nudgeCard.classList.toggle('is-in', !state.nudgeCollapsed);
    els.nudgeFab.classList.toggle('is-in', state.nudgeCollapsed);
  }

  /* ───────── Tiroir ───────── */
  function openCart() {
    if (!els.drawer) return;
    trk('panier:ouvert');
    els.drawer.classList.remove('translate-x-full');
    els.overlay.style.opacity = '1'; els.overlay.style.pointerEvents = 'auto';
    document.body.classList.add('no-scroll');
    if (state.cart) renderNudge(state.cart.items_subtotal_price, state.cart.item_count);
  }
  function closeCart() {
    if (!els.drawer) return;
    els.drawer.classList.add('translate-x-full');
    els.overlay.style.opacity = '0'; els.overlay.style.pointerEvents = 'none';
    document.body.classList.remove('no-scroll');
    if (state.cart) renderNudge(state.cart.items_subtotal_price, state.cart.item_count);
  }
  window.mbbOpenCart = openCart;

  /* Glisser vers la droite pour fermer (tiroirs tactiles). On n'arme le suivi
     que si le geste initial est clairement horizontal, pour ne jamais voler
     le défilement vertical du contenu ni le swipe-retour du navigateur. */
  function bindSwipeClose(el, close, evName) {
    if (!el) return;
    var x0 = 0, y0 = 0, dx = 0, t0 = 0, armed = false, tracking = false;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      dx = 0; armed = false; tracking = true; t0 = Date.now();
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!armed) {
        if (Math.abs(mx) < 12 && Math.abs(my) < 12) return;
        if (mx > 0 && Math.abs(mx) > Math.abs(my) * 1.2) { armed = true; el.style.transition = 'none'; }
        else { tracking = false; return; }
      }
      dx = Math.max(0, mx);
      el.style.transform = 'translateX(' + dx + 'px)';
      e.preventDefault();
    }, { passive: false });
    var end = function () {
      if (!tracking) return;
      tracking = false;
      if (!armed) return;
      armed = false;
      var quick = dx > 40 && (Date.now() - t0) < 260;
      var shouldClose = dx > 96 || quick;
      el.style.transition = '';
      void el.offsetWidth;
      el.style.transform = '';
      if (shouldClose) { close(); if (evName) trk(evName); }
      dx = 0;
    };
    el.addEventListener('touchend', end);
    el.addEventListener('touchcancel', end);
  }

  /* ───────── Ajout / modifs ─────────
     Shopify verrouille le panier le temps d'une écriture : deux appels concurrents et
     l'un des deux se perd. Un simple verrou « occupé » jetait carrément le 2e clic —
     cliquer vite sur deux boutons Ajouter n'en ajoutait qu'un seul, alors que le bouton
     affichait « Ajouté » dans les deux cas. On enchaîne donc les écritures au lieu de
     les ignorer : chaque clic finit par passer, dans l'ordre. */
  var queue = Promise.resolve(), pending = 0;
  function enqueue(fn) {
    pending++;
    var run = queue.catch(function () {}).then(fn);
    queue = run.then(drained, drained);
    return run;
  }
  function drained() { if (pending > 0) pending--; }

  /* ───────── Plafond de stock APPRIS de Shopify ─────────
     La fiche produit connaît l'inventaire TOTAL d'une variante (Liquid additionne tous
     les emplacements), mais le panier, lui, est plafonné par Shopify à ce que
     l'emplacement des commandes EN LIGNE possède — silencieusement : demander 1400
     quand 156 sont vendables renvoie un panier à 156, sans erreur. Quand on surprend
     ce plafonnement, on mémorise la vraie limite (session) et on prévient tout le
     monde : la fiche produit s'abaisse, et le client reçoit un message honnête au
     lieu d'un stepper qui « ne marche pas ». */
  var capMax = null;
  function capLire() {
    if (capMax) return capMax;
    try { capMax = JSON.parse(sessionStorage.getItem('mbb-capmax') || 'null') || {}; }
    catch (e) { capMax = {}; }
    return capMax;
  }
  function capNoter(variantId, max) {
    var m = capLire(), k = String(variantId);
    if (m[k] !== max) {
      m[k] = max;
      try { sessionStorage.setItem('mbb-capmax', JSON.stringify(m)); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('mbb:cap', { detail: { variantId: k, max: max } }));
  }
  function qtyOf(cart, variantId) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (i) {
      if (String(i.variant_id) === String(variantId)) n += i.quantity;
    });
    return n;
  }
  /* À appeler après chaque écriture : si Shopify a donné moins que demandé, la
     quantité obtenue EST le maximum vendable de la variante (le panier le contient
     alors au complet). */
  function verifCap(variantId, attendu, obtenu) {
    if (variantId == null || obtenu >= attendu) return;
    capNoter(variantId, obtenu);
    window.mbbToast(obtenu > 0
      ? tt('stockCap', 'Il n\'en reste que [n] en stock — ils sont tous dans votre panier.').replace('[n]', obtenu)
      : tt('stockCapNone', 'Ce produit n\'est plus en stock.'));
  }

  window.mbbAdd = function (variantId, qty) {
    return enqueue(function () {
      var avant = qtyOf(state.cart, variantId);
      var vise = avant + (parseInt(qty, 10) || 1);

      return addItem(variantId, qty)
        .catch(function (e) {
          /* Stock insuffisant : Shopify répond 422 « 156 articles seulement ont été
             ajoutés… » MAIS il les ajoute quand même. Ce n'est donc pas un échec, c'est
             le stock qui parle. On relit le panier : si la quantité a bougé, on continue
             normalement (verifCap fera le reste). Si rien n'a bougé, c'est une vraie
             erreur et on la laisse remonter. */
          return getCart().then(function (cart) {
            if (qtyOf(cart, variantId) > avant) return cart;
            throw e;
          });
        })
        .then(getCart)
        .then(function (cart) {
          renderCart(cart);
          verifCap(variantId, vise, qtyOf(cart, variantId));
          if (els.count) { els.count.classList.remove('bump'); void els.count.offsetWidth; els.count.classList.add('bump'); }
          maybeReloadCartPage();
          return cart;
        });
    }).catch(function (e) {
      window.mbbToast((e && e.description) || tt('addError', 'Impossible d\'ajouter ce produit.'));
    });
  };

  function maybeReloadCartPage() {
    if (!document.body.classList.contains('template-cart')) return;
    // Recharger tout de suite tuerait les écritures encore en file : on attend qu'elle soit vide.
    setTimeout(function () { if (pending === 0) location.reload(); }, 0);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.js-add');
    if (add && add.dataset.variantId) {
      e.preventDefault();
      var original = add.innerHTML;
      add.classList.add('added');
      add.innerHTML = /Ajouter/i.test(add.textContent) ? '<i class="ph-bold ph-check text-[14px]"></i> Ajouté' : '<i class="ph-bold ph-check text-[14px]"></i>';
      setTimeout(function () { add.classList.remove('added'); add.innerHTML = original; }, 1100);
      window.mbbAdd(add.dataset.variantId, parseInt(add.dataset.qty || '1', 10)).then(function () {
        window.mbbToast('Ajouté au panier');
        if (add.dataset.open === 'cart') openCart();
      });
      return;
    }
    var inc = e.target.closest('.js-inc');
    if (inc) { lineOp(inc, aimed(inc) + 1); return; }
    var dec = e.target.closest('.js-dec');
    if (dec) { lineOp(dec, Math.max(0, aimed(dec) - 1)); return; }
    var rem = e.target.closest('.js-remove');
    if (rem) { lineOp(rem, 0); return; }
  });

  /* Quantité visée par ligne. Trois clics rapides sur « + » lisent tous la même quantité
     affichée (le re-rendu n'a pas encore eu lieu) et demanderaient donc tous 2 au lieu de 4.
     On garde la cible en mémoire jusqu'à ce que l'écriture parte. */
  var aim = Object.create(null);
  function aimed(btn) {
    var k = btn.dataset.key;
    return (k && aim[k] != null) ? aim[k] : parseInt(btn.dataset.qty, 10);
  }
  function lineOp(btn, qty) {
    var key = btn.dataset.key;
    if (!key || isNaN(qty)) return;
    aim[key] = qty;
    enqueue(function () {
      var q = aim[key];
      if (q == null) return; // un clic plus récent a déjà envoyé la cible cumulée
      delete aim[key];
      return changeLine(key, q).then(function (c) {
        renderCart(c);
        // Shopify plafonne silencieusement au stock vendable : sans ce contrôle, le
        // « + » du tiroir semble simplement mort une fois la limite atteinte.
        if (q > 0) {
          var ligne = ((c && c.items) || []).find(function (i) { return i.key === key; });
          if (ligne) verifCap(ligne.variant_id, q, ligne.quantity);
        }
        maybeReloadCartPage();
      });
    }).catch(function () { delete aim[key]; });
  }

  /* Champ quantité de la page panier (rendu serveur) */
  document.addEventListener('change', function (e) {
    var qin = e.target.closest('input[name="updates[]"][data-key]');
    if (!qin) return;
    var q = parseInt(qin.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    lineOp(qin, q);
  });

  /* Formulaire produit : AJAX par-dessus le POST standard (bouton name=add conservé pour les apps) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mbb-ajax]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var variantId = fd.get('id');
    var qty = parseInt(fd.get('quantity') || '1', 10);
    var btn = form.querySelector('button[name="add"], button[type="submit"]');
    if (btn) {
      var o = btn.innerHTML;
      btn.classList.add('added');
      btn.innerHTML = '<i class="ph-bold ph-check text-[15px]"></i> Ajouté';
      setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = o; }, 1100);
    }
    window.mbbAdd(variantId, qty).then(function () { window.mbbToast('Ajouté au panier'); openCart(); });
  });

  /* ───────── Menu mobile ───────── */
  function bindMenu() {
    var menu = $('mobileMenu'), btn = $('menuBtn'), close = $('menuClose');
    if (!menu || !btn) return;
    var open = function () { trk('menu:ouvert'); menu.classList.remove('translate-x-full'); btn.setAttribute('aria-expanded', 'true'); document.body.classList.add('no-scroll'); if (state.cart) renderNudge(state.cart.items_subtotal_price, state.cart.item_count); };
    var shut = function () { menu.classList.add('translate-x-full'); btn.setAttribute('aria-expanded', 'false'); document.body.classList.remove('no-scroll'); if (state.cart) renderNudge(state.cart.items_subtotal_price, state.cart.item_count); };
    btn.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    bindSwipeClose(menu, shut, 'menu:swipe_ferme');
    menu.querySelectorAll('.js-mlink').forEach(function (l) { l.addEventListener('click', shut); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { shut(); closeCart(); if (window.mbbClosePostal) window.mbbClosePostal(); } });
  }

  /* ───────── Code postal · vérificateur de zone de livraison ─────────
     La liste vient du réglage « Zones de livraison » (settings.postal_zones), qui doit
     rester le miroir exact de Paramètres → Expédition et livraison → Livraison locale.
     Format accepté : « H*, J4*, G1A*, J0K2E0 » — préfixe + astérisque, ou code complet.
     On répond OUI ou NON, jamais un délai : les tournées ne sont pas modélisées ici. */
  var PAM_KEY = 'mbb-postal';
  var PAM_ZONES = null;
  function zones() {
    if (PAM_ZONES) return PAM_ZONES;
    var prefixes = [], exacts = [];
    var raw = (window.MBBTHEME && window.MBBTHEME.postalZones) || '';
    raw.split(',').forEach(function (tok) {
      var s = tok.replace(/[^A-Za-z0-9*]/g, '').toUpperCase();
      if (!s) return;
      if (s.indexOf('*') >= 0) {
        var p = s.replace(/\*+$/, '');
        if (p && p.indexOf('*') < 0) prefixes.push(p);
      } else if (/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(s)) exacts.push(s);
    });
    PAM_ZONES = { prefixes: prefixes, exacts: exacts };
    return PAM_ZONES;
  }
  function checkPostal(raw) {
    var c = (raw || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(c)) return { valid: false };
    var z = zones(), ok = z.exacts.indexOf(c) >= 0;
    if (!ok) {
      for (var i = 0; i < z.prefixes.length; i++) {
        if (c.indexOf(z.prefixes[i]) === 0) { ok = true; break; }
      }
    }
    return { valid: true, deliverable: ok, code: c, fsa: c.slice(0, 3) };
  }
  var pam = null;
  try { var s = localStorage.getItem(PAM_KEY); if (s) { var r0 = checkPostal(s); if (r0.valid) pam = r0; } } catch (e) {}
  window.mbbPostal = function () { return pam; };
  window.mbbPostalCheck = checkPostal;
  /* Retourne true si la saisie était valide. Les appelants DOIVENT s'y fier avant d'afficher :
     sur une saisie invalide, `pam` garde la réponse précédente et on afficherait du périmé. */
  window.mbbPostalSubmit = function (raw, fromModal) {
    var r = checkPostal(raw);
    if (!r.valid) { window.mbbToast(tt('postalInvalid', 'Entrez un code postal valide (ex. H2J 2W8).')); return false; }
    pam = r;
    trk(r.deliverable ? 'postal:oui' : 'postal:non');
    try { localStorage.setItem(PAM_KEY, r.code); } catch (e) {}
    document.dispatchEvent(new CustomEvent('mbb:postal', { detail: r }));
    if (!fromModal) window.mbbToast(r.deliverable
      ? tt('postalYes', 'On livre chez vous !')
      : tt('postalNo', 'Pas encore de livraison chez vous'));
    return true;
  };
  /* Affiche la réponse puis la fait disparaître après quelques secondes.
     Partagé par la modale, la page Livraison, la page Où nous trouver et la collection.
     onHide() sert à remettre l'état de départ (remontrer le formulaire ou l'invite). */
  var pamTimers = {};
  window.mbbPostalShow = function (box, onHide) {
    if (!box || !window.mbbPostal) return;
    var r = window.mbbPostal();
    if (!r) return;
    var key = box.id || 'anon';
    if (pamTimers[key]) { clearTimeout(pamTimers[key].a); clearTimeout(pamTimers[key].b); }
    box.innerHTML = window.mbbPostalResultHTML(r);
    box.style.transition = '';
    box.style.opacity = '1';
    box.classList.remove('hidden');
    var secs = (window.MBBTHEME && window.MBBTHEME.postalResultSeconds) || 5;
    var t = {};
    t.a = setTimeout(function () {
      box.style.transition = 'opacity 400ms ease';
      box.style.opacity = '0';
      t.b = setTimeout(function () {
        box.classList.add('hidden');
        box.style.opacity = '';
        box.style.transition = '';
        box.innerHTML = '';
        if (typeof onHide === 'function') onHide();
      }, 420);
    }, secs * 1000);
    pamTimers[key] = t;
  };
  /* Bloc de réponse — partagé par la modale, la page Livraison et la page Où nous trouver */
  window.mbbPostalResultHTML = function (r) {
    if (r.deliverable) {
      return '<div class="rounded-[12px] bg-success/8 ring-1 ring-success/30 p-4">'
        + '<div class="flex items-center gap-2 text-[14px] font-semibold text-success"><i class="ph-fill ph-check-circle text-[16px]"></i> '
        + esc(tt('postalYes', 'On livre chez vous !')) + '</div>'
        + '<p class="mt-1.5 text-[13px] text-ink-600">' + esc(tt('postalYesText', 'Votre secteur fait partie de nos tournées. Choisissez la livraison au moment de payer.')) + '</p></div>';
    }
    return '<div class="rounded-[12px] bg-warn/8 ring-1 ring-warn/30 p-4">'
      + '<div class="flex items-center gap-2 text-[14px] font-semibold text-warn"><i class="ph-fill ph-map-pin text-[16px]"></i> '
      + esc(tt('postalNo', 'Pas encore de livraison chez vous')) + '</div>'
      + '<p class="mt-1.5 text-[13px] text-ink-600">' + esc(tt('postalNoText', 'Aucune tournée ne dessert le secteur')) + ' <span class="font-mono">' + esc(r.fsa) + '</span> ' + esc(tt('postalNoText2', 'pour le moment. Écrivez-nous, on vous dira ce qui est possible.')) + '</p></div>';
  };
  function bindPostalModal() {
    var ov = $('pamModalOverlay'), modal = $('pamModal');
    if (!modal) return;
    var card = modal.querySelector('.pam-card'), input = $('pamInput'), form = $('pamForm'), result = $('pamResult');
    function open() {
      if (result) { result.classList.add('hidden'); result.innerHTML = ''; }
      if (form) form.classList.remove('hidden');
      ov.style.opacity = '1'; ov.style.pointerEvents = 'auto';
      modal.style.opacity = '1'; modal.style.pointerEvents = 'auto';
      if (card) card.style.transform = 'translateY(0) scale(1)';
      document.body.classList.add('no-scroll');
      setTimeout(function () { if (input) { input.value = ''; input.focus(); } }, 60);
    }
    function close() {
      ov.style.opacity = '0'; ov.style.pointerEvents = 'none';
      modal.style.opacity = '0'; modal.style.pointerEvents = 'none';
      if (card) card.style.transform = 'translateY(12px) scale(0.98)';
      document.body.classList.remove('no-scroll');
    }
    window.mbbOpenPostal = open;
    window.mbbClosePostal = close;
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!window.mbbPostalSubmit(input.value, true)) return; // saisie invalide : le toast a parlé
      if (!result) return;
      form.classList.add('hidden');
      window.mbbPostalShow(result, function () {
        form.classList.remove('hidden');
        if (input) input.value = '';
      });
    });
    var closeBtn = $('pamClose'); if (closeBtn) closeBtn.addEventListener('click', close);
    if (ov) ov.addEventListener('click', close);
    /* Déclencheurs : barre d'annonce du header, menu mobile, ou n'importe quel .js-postal-open */
    document.querySelectorAll('.js-postal-open').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
  }

  /* ───────── Init ───────── */
  function init() {
    grab();
    bindMenu();
    bindPostalModal();
    var cartBtn = $('cartBtn'); if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    var cartClose = $('cartClose'); if (cartClose) cartClose.addEventListener('click', closeCart);
    bindSwipeClose(els.drawer, closeCart, 'panier:swipe_ferme');
    if (els.overlay) els.overlay.addEventListener('click', closeCart);
    document.querySelectorAll('.cartCloseInner').forEach(function (b) { b.addEventListener('click', closeCart); });
    var hs = $('headerShipCart'); if (hs) hs.addEventListener('click', openCart);
    var nMin = $('nudgeMin'); if (nMin) nMin.addEventListener('click', function () { state.nudgeCollapsed = true; renderCart(state.cart); });
    if (els.nudgeFab) els.nudgeFab.addEventListener('click', function () { state.nudgeCollapsed = false; renderCart(state.cart); });
    var nView = $('nudgeViewCart'); if (nView) nView.addEventListener('click', function () { state.nudgeCollapsed = true; openCart(); });
    getCart().then(renderCart);
    window.mbbRefreshCart = function () { getCart().then(renderCart); };
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ── Notes produits (étoiles) sur les cartes, partout sur le site ──
   Une seule requête (résumé de tous les produits notés), cache 10 minutes,
   puis remplissage des emplacements .mbb-rating-slot rendus par mbb-product-card. */
(function () {
  function init() {
    var slots = document.querySelectorAll('.mbb-rating-slot');
    if (!slots.length) return;
    var api = ((window.MBBTHEME && MBBTHEME.apiUrl) || '').replace(/\/+$/, '');
    if (!api) return;
    function stars(n) {
      var h = '';
      for (var i = 1; i <= 5; i++) h += '<i class="' + (i <= n ? 'ph-fill' : 'ph') + ' ph-star"></i>';
      return h;
    }
    function paint(sum) {
      slots.forEach(function (el) {
        var s = sum[el.getAttribute('data-rhandle')];
        if (!s || !s.count) return;
        el.innerHTML = '<span class="text-brand-red inline-flex items-center gap-0.5">' + stars(Math.round(s.average)) + '</span>' +
          '<b>' + String(s.average).replace('.', ',') + '</b><span class="text-ink-400">(' + s.count + ')</span>';
        el.classList.remove('hidden');
        el.classList.add('flex');
      });
    }
    var KEY = 'mbb-rsum';
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < 600000) { paint(c.d || {}); return; }
    } catch (e) {}
    fetch(api + '/api/reviews/summary')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var sum = d.summary || {};
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: sum })); } catch (e) {}
        paint(sum);
      })
      .catch(function () {});
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();